// src/constants/siteInfo.ts

// 0 = Dimanche, 1 = Lundi, 2 = Mardi, etc.
type Day = 0 | 1 | 2 | 3 | 4 | 5 | 6;

interface TimeRange {
  open: number;
  close: number;
}

interface ServicesHours {
  restaurant?: TimeRange[];
  etangs?: TimeRange[];
}

interface OpeningHours {
  day: Day;
  services?: ServicesHours; // Undefined si tout est fermé
}

const restaurantHours = [{ open: 12, close: 14 }];
const etangsHours = [{ open: 8, close: 18 }];

const standardPeriod: OpeningHours[] = [
  { day: 0, services: { restaurant: restaurantHours, etangs: etangsHours } }, // Dimanche
  { day: 1 }, // Lundi (Fermé)
  { day: 2 }, // Mardi (Fermé)
  { day: 3, services: { restaurant: restaurantHours, etangs: etangsHours } }, // Mercredi
  { day: 4, services: { restaurant: restaurantHours, etangs: etangsHours } }, // Jeudi
  { day: 5, services: { restaurant: restaurantHours, etangs: etangsHours } }, // Vendredi
  { day: 6, services: { restaurant: restaurantHours, etangs: etangsHours } }, // Samedi
];

export const siteInfo = {
  phone: "03 86 22 22 61",
  address: "Le Moulin Tala, 58230 Brassy",
  seasonText: "Ouvert chaque année du premier week-end de mars au premier week-end de novembre (fermeture hivernale de novembre à fin février)",
  openingHours: {
    standard: standardPeriod,
    // La logique d'été et jours fériés est gérée dynamiquement
    special: {
        restaurant: restaurantHours,
        etangs: etangsHours,
    }
  },
  daysOfWeek: [
    "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"
  ],
};

export type { OpeningHours, TimeRange, Day, ServicesHours }; 